'use strict';

bbw.model.PhotoCollection = ngtk.model.List.extend({

    statics: {
        REQUEST_TMPL: '/api/photos/get/{user_id}/{photo_ids}/{size_name}/{full_size_name?}/{extra_size_name?}'
    },

    _itemModel: bbw.model.Photo,

    _count: undefined,

    _loadArgs: undefined,

    _userId: undefined,

    _photosLimit: undefined,

    setPhotosLimit: function(limit) {
        this._photosLimit = limit;
        return this;
    },

    getPhotosLimit: function() {
        return this._photosLimit;
    },

    getRemainingPhotoSlotsCount: function() {
        if (this._photosLimit) {
            return this.getPhotosLimit() - this.getLength();
        }
        return undefined;
    },

    setUserId: function(id) {
        this._userId = id || undefined;
        return this;
    },

    addPhoto: function(photo, force) {
        if (!force) {
            if (this._photosLimit && this.getCount() >= this._photosLimit) {
                return false;
            }
        }
        if (!photo instanceof bbw.model.Photo) {
            throw new Error("Invalid argument: Photo expected");
        }
        var photoId = photo.get('id');
        if (!photoId) {
            throw new Error("Photo id is undefined");
        }
        this.set(photoId, photo);
        return true;
    },

    removePhoto: function(photo) {
        var photoId = photo.get('id');
        if (!photoId) {
            throw new Error("Photo id is undefined");
        }
        this.unset(photoId);
    },

    exportPhotoIds: function() {
        var result = [];
        this.forEach(function(photo) {
            photo.get('id') && result.push(photo.get('id'));
        });
        return result;
    },

    load: function(photo_ids, size_name, full_size_name, extra_size_name) {
        if (!angular.isArray(photo_ids)) {
            throw new Error('not an array');
        }
        this._loadArgs = {
            user_id: this._userId,
            photo_ids: photo_ids.join(','),
            size_name: size_name || undefined,
            full_size_name: full_size_name || undefined,
            extra_size_name: extra_size_name || undefined
        };
        return this._load();
    },

    getCount: function() {
        return this._count;
    },

    getLength: function() {
        return Object.keys(this._items).length;
    },

    reload: function() {
        return this._load();
    },

    _load: function() {
        if (angular.isUndefined(this._loadArgs)) {
            throw new Error('loadArgs not defined');
        }
        if (this._loadArgs.photo_ids.length == 0) {
            this._setFromApiResult([]);
            this._count = 0;
            return this.$q.when();
        }
        return this._loadFromApi('get', bbw.model.PhotoCollection.REQUEST_TMPL, attrs).then(function(response) {
            this._setFromApiResult(response.photos.items);
            this._count = response.photos.count;
        }.bind(this));
    }

});